import { useSelector } from 'react-redux';
import { uiStateSelector } from 'state/selectors/ui-state';
import { useState, useEffect } from 'react';
import useGroupsTeam from '../useGroupTeams/useGroupTeams';
import {
  SESSION_STORAGE_KEYS,
  STORAGE_TYPES
} from 'common/constants/constants';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import useFetchGroupTableMetrics from '../useFetchGroupTableMetrics/useFetchGroupTableMetrics';

// Manages the data for the table, makes api calls and has onClick logic
const useGroupTableDataNew = ({
  groupsManagedPages,
  tableMetricsNames,
  setExpandedTeamId
}) => {
  const [aggregatedMetrics, setAggregatedMetrics] = useState([]);
  const [metricsPerGranularity, setMetricsPerGranularity] = useState([]);
  const [aggregatedLastPeriodMetrics, setAggregatedLastPeriodMetrics] =
    useState([]);
  const [metricsPerGranularityLastPeriod, setMetricsPerGranularityLastPeriod] =
    useState([]);
  const uiState = useSelector(uiStateSelector);
  const { dates } = uiState;
  const { selectedGroupId } = useGroupsTeam();

  const sessionStorageAccessor =
    BrowserStorageAccessor()[STORAGE_TYPES.SESSION];

  const { isLoadingTable, isExpandingTable, fetchMetrics, lastPeriodDates } =
    useFetchGroupTableMetrics({
      setAggregatedMetrics,
      setMetricsPerGranularity,
      setAggregatedLastPeriodMetrics,
      setMetricsPerGranularityLastPeriod,
      groupsManagedPages,
      tableMetricsNames
    });

  const onLoadMoreClick = group => {
    const groupId = group?.id;
    groupsManagedPages.nextPage(groupId);
    const groupChildren = group?.children.map(({ id }) => id) || [];
    const offset = groupsManagedPages.getOffset(groupId);
    const teamIdsToFetch = groupChildren.slice(
      offset,
      offset + groupsManagedPages.pageSize
    );
    fetchMetrics(teamIdsToFetch);
  };

  const onExpandClick = group => {
    const groupId = group?.id;
    if (!groupsManagedPages.managedPages[groupId]) {
      groupsManagedPages.getPage(groupId);
      const selectedGroupChildrenIds =
        group?.children.map(({ id }) => id) || [];
      const teamIdsToFetch = selectedGroupChildrenIds.slice(
        0,
        groupsManagedPages.pageSize
      );
      setExpandedTeamId(groupId);
      fetchMetrics(teamIdsToFetch);
    }
  };

  useEffect(() => {
    sessionStorageAccessor.remove(
      SESSION_STORAGE_KEYS.GROUP_DASHBOARD.TABLE.EXPANDED_ROWS_STATE
    );
  }, [dates?.from, dates?.to, selectedGroupId, tableMetricsNames]);

  return {
    aggregatedMetrics,
    metricsPerGranularity,
    aggregatedLastPeriodMetrics,
    metricsPerGranularityLastPeriod,
    isLoadingTable,
    isExpandingTable,
    lastPeriodDates,
    onLoadMoreClick,
    onExpandClick
  };
};

export default useGroupTableDataNew;
